import CreateBobjectButton from './addButton.container';

export default CreateBobjectButton;
